module.exports = __webpack_public_path__ + "img/default.013dcd37.jpg";